import styled from 'styled-components';
import { Para } from '../Typography';

export const Container = styled.div`
  width: 80%;
  display: flex;
  align-content: space-between;
`;
export const Card = styled.div`
  padding: 2.5em;
  position: relative;
  margin: 0px 0px 30px;
  box-shadow: rgb(0 0 0 / 15%) 0px 0.5rem 1rem;
  width: 83.3%;
  border-right: 4px solid #4e6e29;
  background-color: #fff;
`;
export const CardTitle = styled.h3`
  font-weight: 700;
  font-size: 2rem;
  color: #333333;
  margin: 15px 0px;
  line-height: 1.2;
`;
export const CardPlace = styled.h4`
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  font-size: 1.5rem;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  color: #4e6e29;
`;
export const Details = styled(Para)`
  line-height: 1.65;
  font-size: 1.35rem;
  color: #555555cf;
`;
export const ShowDate = styled.div`
  width: 17%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 3.5rem;
`;
export const Line = styled.div`
  height: 100%;
  border-right: 3.5px solid #4e6e29;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    right: -18px;
    width: 3.1rem;
    height: 3.1rem;
    border-radius: 50%;
    background-color: #4e6e29;
  }
`;
